import { OASBooking } from '../features/book-appointment/booking-wrapper';

export default OASBooking;
